import React, { Fragment, useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import { useNavigate, useParams } from "react-router-dom";
import Breadcrumb from "../components/Admin/Reusable/Breadcrumb";
import { useTranslation } from "react-i18next";
import { Card, Col, Container, Row } from "react-bootstrap";

import CheckCircleOutlineOutlinedIcon from "@mui/icons-material/CheckCircleOutlineOutlined";
import CloseOutlinedIcon from "@mui/icons-material/CloseOutlined";
import { Button, TextField } from "@mui/material";
import CustomModal from "../components/Common/Modal/CustomModal";
import { toast } from "react-toastify";
import { useSelector } from "react-redux";
import { formatDateFull, formatOnlyDate } from "../utils";
import FormTitleMain from "../components/Admin/Reusable/FormTitleMain";
import FileDownloadOutlinedIcon from "@mui/icons-material/FileDownloadOutlined";
import { fetchContactById } from "../actions/contact";

const EducatorContactDetail = () => {
  const { id } = useParams();
  const { t } = useTranslation();
  const dispatch = useDispatch();

  const { contactDetail } = useSelector((state) => state.contactReducer);
console.log(contactDetail,"detaill");
  //breadcrumb
  const translateModule = "educatorContact";
  const pageType = id ? "Edit" : "Add";
  const breadcrumbItems = [
    { label: t(`breadcrumb.${translateModule}`) },
    {
      label: t(`breadcrumb.${translateModule}${pageType}`),
      active: true,
    },
  ];

  useEffect(() => {
    dispatch(fetchContactById(id));
  }, [dispatch, id]);

  return (
    <Fragment>
      <Breadcrumb
        breadcrumbItems={breadcrumbItems}
        type={`${translateModule}${pageType}`}
        id={id}
        pageType={pageType}
      />
      <Container>
        <Row>
          <Col lg={12}>
            <Row>
              <Col lg={12}>
                <Card>
                  <Card.Header>
                    <FormTitleMain />
                  </Card.Header>
                  <Card.Body>
                    <div className="receipt-detail-item">
                      Ime i prezime:{" "}
                      <b>
                        {contactDetail?.fullName}{" "}
                      </b>
                    </div>
                    <div className="receipt-detail-item">
                        Email adresa:{" "}
                        {contactDetail?.email}{" "}
                    </div>
                    <div className="receipt-detail-item">
                        {t("contactDetail.workType")}:{" "}
                       <b>{contactDetail?.workType}{" "}</b>
                    </div>
                    <div className="receipt-detail-item">
                        {t("contactDetail.title")}:{" "}
                       <b>{contactDetail?.title}{" "}</b>
                    </div>
                     <div className="receipt-detail-item">
                      {t("contactDetail.message")}:{" "}
                         <b>{contactDetail?.message}{" "}</b>
                    </div>
                 
                    <div className="receipt-detail-item">
                      {t("contactDetail.createdDate")}:{" "}
                      <b>{formatDateFull(contactDetail?.createdAt)}</b>
                    </div>


                    {/* <table className="table table-breceipted table-striped mt-3">
                      <thead>
                        <tr>
                          <th>{t("contactDetail.product")}</th>
                          <th>{t("contactDetail.type")}</th>
                          <th>{t("contactDetail.totalPoints")}</th>
                          <th>{t("contactDetail.accessDuration")}</th>
                        </tr>
                      </thead>
                      <tbody>
                        {contactDetail?.items?.map((item, key) => (
                          <tr key={key}>
                            <td>{item?.name}</td>
                            <td>{item?.itemType}</td>
                            <td>{item?.accessDuration} dana</td>
                          </tr>
                        ))}
                      </tbody>
                    </table> */}
                  </Card.Body>
                </Card>
              </Col>
            </Row>
          </Col>
        </Row>
      </Container>
    </Fragment>
  );
};

export default EducatorContactDetail;
